Revolution.Module.extend({
    NAME: "mde.account", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/account.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        // _.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        $('.js-delete-alerte').on('click', this.confirmDelete);

        $('#form-infos-cnx').parsley();
        $('#form-infos-account').parsley();
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {
    },

    confirmDelete: function () {
        confirm('Voulez-vous vraiment supprimer cette alerte ?');
    }
});
